import { render, staticRenderFns } from "./ApproveCar.vue?vue&type=template&id=6e6e23ea&"
import script from "./ApproveCar.vue?vue&type=script&lang=js&"
export * from "./ApproveCar.vue?vue&type=script&lang=js&"
import style0 from "./ApproveCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports